export default __webpack_public_path__ + "static/media/messageIcon.846e0d0a.svg";